import React from 'react';

const Alert = () => (
  <div className="alert">Thank you, message sent</div>
);

export default Alert;
